"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireWildcard(require("@/router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
// import router from './router'

// progress bar
// progress bar style
// get token from cookie
// import getPageTitle from '@/utils/get-page-title'

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/ssoRedirect', '/login', '/accountLogin', '/testAccountLogin', '/saLogin', '/testSaLogin', '/ckContent']; // no redirect whitelist

_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(to, from, next) {
    var hasToken, isAddRoute, accessRoutes, functions, _t;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          // document.title = getPageTitle(to.meta.title)

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)(); // const hasSystem = getSystem()
          // console.log('------hasToken---', hasToken)
          // console.log('------hasSystem---', hasSystem)
          if (hasToken) {
            _context.n = 1;
            break;
          }
          /* has no token */

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
          return _context.a(2);
        case 1:
          if (!(to.path === '/login' || to.path === '/system')) {
            _context.n = 2;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.n = 6;
          break;
        case 2:
          // determine whether the user has obtained his permission roles through getInfo
          // const hasRoles = store.getters.roles && store.getters.roles.length > 0
          isAddRoute = _store.default.getters.isAddRoute; // console.log('isAddRoute-----', isAddRoute)
          // 刷新后addRoute会失效
          if (!isAddRoute) {
            _context.n = 3;
            break;
          }
          next();
          _context.n = 6;
          break;
        case 3:
          _context.p = 3;
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          // const { roles } = await store.dispatch('user/setInfo')

          (0, _router.resetRouter)();
          // generate accessible routes map based on roles
          accessRoutes = _store.default.getters.original_back_routes;
          functions = _store.default.getters.functions;
          _store.default.dispatch('nocache/setAddRoute', {
            isAddRoute: true
          });
          _store.default.dispatch('permission/generateFunctions', functions);
          _store.default.dispatch('permission/generateRoutes', accessRoutes).then(function (res) {
            // console.log(res)
            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
              replace: true
            }));
          });

          // router.addRoutes(a)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record

          // NProgress.done()
          _context.n = 6;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          _context.n = 5;
          return _store.default.dispatch('user/resetToken');
        case 5:
          _elementUi.Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[3, 4]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});